import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import {
  DetailContext,
  DetailHandle,
  FormSelect,
  useFormSelector,
  useStaticListSource,
} from '@eas/common-web';
import { StaticDataContext } from '@components/evidence/static-data-provider/static-data-provider';
import { DisciplinaryProceedingsFile } from '@models';
import { Agenda, EsFileState } from '@enums';
import { UnfinishedTasksWarning } from '@composite/tasks/unfinished-tasks-warning';

const useStyles = makeStyles(() => ({
  divider: {
    width: '100%',
    margin: '10px 0',
  },
}));

export function useFormFields() {
  const { states } = useContext(StaticDataContext);
  const { source } =
    useContext<DetailHandle<DisciplinaryProceedingsFile>>(DetailContext);

  return function FormFields() {
    const classes = useStyles();
    const selectedState = useFormSelector((data: { state?: EsFileState }) => data?.state);

    const filtered = states
      .filter(
        (state) =>
          state?.forAgendas?.includes(Agenda.DISCIPLINARY_PROCEEDINGS) &&
          state.id !== EsFileState.REGISTRY &&
          state.id !== EsFileState.SHREDDED
      )
      .filter((state) => {
        if (source.data?.state === EsFileState.NEW) {
          return state.id !== EsFileState.NEW;
        }
        if (source.data?.state === EsFileState.IN_PROGRESS) {
          return state.id !== EsFileState.IN_PROGRESS;
        }
      });

    const statesSource = useStaticListSource(filtered);

    return (
      <>
        <FormSelect
          source={statesSource}
          name="state"
          label={
            <FormattedMessage
              id="ES__DISCIPLINARY_PROCEEDINGS_FILE__CHANGE_SATE_HOOK__FIELD_LABEL__STATE"
              defaultMessage="Stav"
            />
          }
          labelOptions={{
            hide: true,
          }}
          valueIsId={true}
        />
        {selectedState && [EsFileState.CLOSED, EsFileState.ACCEPTED, EsFileState.REJECTED, EsFileState.WITHDRAWN].includes(selectedState) && (
          <UnfinishedTasksWarning esFileId={source.data?.id} />
        )}
        <div className={classes.divider} />
      </>
    );
  };
}
